import moment from "moment";
import WebService from "./WebService";
import Store from "./StoreService";
class HelperService {
    sorting(sortBy, id) {
        var orderBy = "ASC";
        var className = "sorting_asc";
        var temp = document.getElementById(id);
        if (temp) {
            if (temp.className.includes("sorting_asc")) {
                className = "sorting_desc";
            }
            if (className == "sorting_asc") {
                temp.classList.add("sorting_asc");
                temp.classList.remove("sorting_desc");
                orderBy = "ASC";
            } else if (className == "sorting_desc") {
                temp.classList.add("sorting_desc");
                temp.classList.remove("sorting_asc");
                orderBy = "DESC";
            }
        }
        var obj = {
            order_by: orderBy,
            sort_by: sortBy,
        };
        return obj;
    }
    kFormatter(num) {
        return Math.abs(num) > 999 ? Math.sign(num) * ((Math.abs(num) / 100000).toFixed(2)) + '' : Math.sign(num) * Math.abs(num)
    }
    getFormatedDate(d) {
        if (d == "0000-00-00") {
            return '-';
        }
        return moment(d).format("DD-MM-YYYY");
    }
    getUrl(d) {
        if (d.includes('http')) {
            return d;
        } else {
            return 'http://' + d;
        }

    }
    getFormatDate(d) {
        if (d == "0000-00-00") {
            return '-';
        }
        return moment(d).format("DD MMM YYYY")
    }

    getNewFormatDate(d) {
        if (d == "0000-00-00") {
            return '-';
        }
        return moment(d).format("DD-MM-YYYY")
    }

    getFormatedTime(t) {
        return moment(t, 'HH:mm:ss').format("hh:mm A");
    }
    getFormated24Time(t) {
        return moment(t).format("HH:MM:SS");
    }

    getFormatedDateAndTime(dt) {
        if (dt == "0000-00-00") {
            return '-';
        }
        // return moment.utc(dt).local().format("DD/MM/YYYY hh:mm A");
        return moment(dt).format("DD/MM/YYYY hh:mm A");
    }

    sendFormatedDate(d, type) {
        if (d == "0000-00-00") {
            return '-';
        }
        if (type == "date") {
            return moment(d).format("YYYY-MM-DD");
        } else if (type == "month_year") {
            return moment(d).format("YYYY-MM");
        } else if (type == "year") {
            return moment(d).format("YYYY");
        } else {
            return moment(d).format("YYYY-MM-DD");
        }
    }

    allowOnlyNumericValue(e) {
        var numbers = /^[0-9]$/;
        if (!e.key.match(numbers) && e.keyCode != 8) {
            e.preventDefault();
            return false;
        }
    }
    allowOnlyNumericWithOperaterValue(e) {
        var numbers = /^[0-9+\-*/]+$/;
        if (!e.key.match(numbers) && e.keyCode != 8) {
            e.preventDefault();
            return false;
        }
    }
    maxInput(e, limit) {
        if (e.target.value.length >= limit) {
            e.preventDefault();
            return false;
        }
    }
    getHeight(n) {
        if (n) {
            var realFeet = ((n * 0.393700) / 12);
            var feet = Math.floor(realFeet);
            var inches = Math.round((realFeet - feet) * 12);
            if (inches == 12) {
                feet = feet + 1;
                inches = 0;
                return feet + "'" + inches + '"';
            } else {
                return feet + "'" + inches + '"';
            }
        }
    }
    getTitleCase(value) {
        if (!value) {
            return "";
        } else {
            var str = "";
            var arr = value.split("_");
            for (var i in arr) {
                if (i == 0) {
                    str =
                        arr[i].charAt(0).toUpperCase() + arr[i].substring(1).toLowerCase();
                } else {
                    str +=
                        "" +
                        arr[i].charAt(0).toUpperCase() +
                        arr[i].substring(1).toLowerCase();
                }
            }
            return str;
        }
    }
    getSummary() {
        WebService.getAPI({
            _action: "summary",
        })
            .then((res) => {
                Store.commit("setSummary", res);
            })
            .catch(() => { });
    }
    getText(text, length) {
        if (text && length && text.length > length) {
            return text.substring(0, length) + '...';
        }

        return text;
    }
    numDifferentiation($value) {
        var val = Math.abs($value)
        if (val >= 10000000) {
            val = (val / 10000000).toFixed(2) + ' Cr';
        } else if (val >= 100000) {
            val = (val / 100000).toFixed(2) + ' Lac';
        }
        return val;
    }
}

export default new HelperService({});